<template>
  <div class="loading-ring">
    <span>Loading</span>
  </div>
</template>

<script>
export default {
  name: 'ComSpinner',
};
</script>
